(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9167],{

/***/ 24603:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var global = __webpack_require__(17854);
var isForced = __webpack_require__(54705);
var inheritIfRequired = __webpack_require__(79587);
var createNonEnumerableProperty = __webpack_require__(68880);
var defineProperty = (__webpack_require__(3070).f);
var getOwnPropertyNames = (__webpack_require__(8006).f);
var isRegExp = __webpack_require__(47850);
var toString = __webpack_require__(41340);
var getFlags = __webpack_require__(67066);
var stickyHelpers = __webpack_require__(52999);
var redefine = __webpack_require__(31320);
var fails = __webpack_require__(47293);
var has = __webpack_require__(86656);
var enforceInternalState = (__webpack_require__(29909).enforce);
var setSpecies = __webpack_require__(96340);
var wellKnownSymbol = __webpack_require__(5112);
var UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
var UNSUPPORTED_NCG = __webpack_require__(38173);

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
// TODO: Use only propper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = string.charAt(index);
    if (chr === '\\') {
      result += chr + string.charAt(++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = string.charAt(index);
    if (chr === '\\') {
      chr = chr + string.charAt(++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (IS_NCG.test(string.slice(index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || has(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named.push([groupname, groupid]);
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || pattern instanceof RegExpWrapper) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = 'flags' in rawPattern ? rawPattern.flags : getFlags.call(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && flags.indexOf('s') > -1;
      if (dotAll) flags = flags.replace(/s/g, '');
    }

    rawFlags = flags;

    if (UNSUPPORTED_Y && 'sticky' in re1) {
      sticky = !!flags && flags.indexOf('y') > -1;
      if (sticky) flags = flags.replace(/y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxy(keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ 28450:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
var defineProperty = (__webpack_require__(3070).f);
var getInternalState = (__webpack_require__(29909).get);
var RegExpPrototype = RegExp.prototype;

// `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
if (DESCRIPTORS && UNSUPPORTED_DOT_ALL) {
  defineProperty(RegExpPrototype, 'dotAll', {
    configurable: true,
    get: function () {
      if (this === RegExpPrototype) return undefined;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (this instanceof RegExp) {
        return !!getInternalState(this).dotAll;
      }
      throw TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),

/***/ 88386:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var UNSUPPORTED_Y = (__webpack_require__(52999).UNSUPPORTED_Y);
var defineProperty = (__webpack_require__(3070).f);
var getInternalState = (__webpack_require__(29909).get);
var RegExpPrototype = RegExp.prototype;

// `RegExp.prototype.sticky` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.sticky
if (DESCRIPTORS && UNSUPPORTED_Y) {
  defineProperty(RegExpPrototype, 'sticky', {
    configurable: true,
    get: function () {
      if (this === RegExpPrototype) return undefined;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (this instanceof RegExp) {
        return !!getInternalState(this).sticky;
      }
      throw TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),

/***/ 4723:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(27007);
var anObject = __webpack_require__(19670);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);
var advanceStringIndex = __webpack_require__(31530);
var regExpExec = __webpack_require__(97651);

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ 83510:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
defineWellKnownSymbol('replace');


/***/ }),

/***/ 42118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIsNaN = __webpack_require__(62722),
    strictIndexOf = __webpack_require__(42351);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 62722:
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 47415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ 42351:
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 64721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(42118),
    isArrayLike = __webpack_require__(98612),
    isString = __webpack_require__(47037),
    toInteger = __webpack_require__(40554),
    values = __webpack_require__(52628);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),

/***/ 47037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isArray = __webpack_require__(1469),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 10928:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 52628:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseValues = __webpack_require__(47415),
    keys = __webpack_require__(3674);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),

/***/ 79167:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ formatValue; },
/* harmony export */   "EK": function() { return /* binding */ checkNumberValidity; },
/* harmony export */   "YM": function() { return /* binding */ unformatValue; },
/* harmony export */   "fO": function() { return /* binding */ checkTelValidity; },
/* harmony export */   "ft": function() { return /* binding */ sanitizeAndFormatNumberWithCommas; },
/* harmony export */   "zL": function() { return /* binding */ checkEmailValidity; }
/* harmony export */ });
/* unused harmony exports mailcheckDefaultDomains, BLACKLISTED_TLDS, formatPercent, formatNumber, formatCurrencyValue */
/* harmony import */ var lodash_last_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10928);
/* harmony import */ var lodash_includes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64721);
/* harmony import */ var lodash_get_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27361);
/* harmony import */ var core_js_modules_es_symbol_replace_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83510);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_async_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72443);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_to_string_tag_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39341);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69600);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85827);
/* harmony import */ var core_js_modules_es_array_reverse_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(65069);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_json_stringify_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(38862);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(56977);
/* harmony import */ var core_js_modules_es_json_to_string_tag_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(73706);
/* harmony import */ var core_js_modules_es_math_to_string_tag_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(10408);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(68304);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_parse_float_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(54678);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(24603);
/* harmony import */ var core_js_modules_es_regexp_dot_all_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(28450);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_sticky_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(88386);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(4723);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_weak_map_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(4129);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(33948);
/* harmony import */ var mailcheck__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(62320);
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(75565);
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(5559);
/* harmony import */ var validator_lib_isEmail_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(83868);
/* harmony import */ var _helpers_currencyHelpers_mjs__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(97166);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }



function cov_25bxqxe5o4() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Input/helpers.ts";
  var hash = "9061f879f06d761431a15347495d4a2fae637557";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Input/helpers.ts",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 40
        },
        end: {
          line: 10,
          column: 76
        }
      },
      "1": {
        start: {
          line: 12,
          column: 43
        },
        end: {
          line: 12,
          column: 52
        }
      },
      "2": {
        start: {
          line: 14,
          column: 28
        },
        end: {
          line: 14,
          column: 37
        }
      },
      "3": {
        start: {
          line: 15,
          column: 37
        },
        end: {
          line: 15,
          column: 57
        }
      },
      "4": {
        start: {
          line: 16,
          column: 34
        },
        end: {
          line: 16,
          column: 63
        }
      },
      "5": {
        start: {
          line: 18,
          column: 39
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "6": {
        start: {
          line: 41,
          column: 32
        },
        end: {
          line: 41,
          column: 76
        }
      },
      "7": {
        start: {
          line: 43,
          column: 21
        },
        end: {
          line: 59,
          column: 1
        }
      },
      "8": {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 58,
          column: 5
        }
      },
      "9": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 57,
          column: 7
        }
      },
      "10": {
        start: {
          line: 48,
          column: 19
        },
        end: {
          line: 48,
          column: 30
        }
      },
      "11": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 54,
          column: 9
        }
      },
      "12": {
        start: {
          line: 51,
          column: 10
        },
        end: {
          line: 51,
          column: 77
        }
      },
      "13": {
        start: {
          line: 53,
          column: 10
        },
        end: {
          line: 53,
          column: 22
        }
      },
      "14": {
        start: {
          line: 61,
          column: 34
        },
        end: {
          line: 67,
          column: 1
        }
      },
      "15": {
        start: {
          line: 64,
          column: 16
        },
        end: {
          line: 64,
          column: 85
        }
      },
      "16": {
        start: {
          line: 65,
          column: 21
        },
        end: {
          line: 65,
          column: 46
        }
      },
      "17": {
        start: {
          line: 66,
          column: 2
        },
        end: {
          line: 66,
          column: 31
        }
      },
      "18": {
        start: {
          line: 69,
          column: 32
        },
        end: {
          line: 72,
          column: 1
        }
      },
      "19": {
        start: {
          line: 70,
          column: 16
        },
        end: {
          line: 70,
          column: 55
        }
      },
      "20": {
        start: {
          line: 71,
          column: 2
        },
        end: {
          line: 71,
          column: 34
        }
      },
      "21": {
        start: {
          line: 74,
          column: 35
        },
        end: {
          line: 89,
          column: 1
        }
      },
      "22": {
        start: {
          line: 79,
          column: 14
        },
        end: {
          line: 79,
          column: 18
        }
      },
      "23": {
        start: {
          line: 80,
          column: 20
        },
        end: {
          line: 80,
          column: 73
        }
      },
      "24": {
        start: {
          line: 81,
          column: 19
        },
        end: {
          line: 81,
          column: 40
        }
      },
      "25": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 84,
          column: 3
        }
      },
      "26": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 18
        }
      },
      "27": {
        start: {
          line: 85,
          column: 2
        },
        end: {
          line: 87,
          column: 3
        }
      },
      "28": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 18
        }
      },
      "29": {
        start: {
          line: 88,
          column: 2
        },
        end: {
          line: 88,
          column: 15
        }
      },
      "30": {
        start: {
          line: 91,
          column: 29
        },
        end: {
          line: 102,
          column: 1
        }
      },
      "31": {
        start: {
          line: 92,
          column: 20
        },
        end: {
          line: 92,
          column: 73
        }
      },
      "32": {
        start: {
          line: 93,
          column: 18
        },
        end: {
          line: 93,
          column: 62
        }
      },
      "33": {
        start: {
          line: 97,
          column: 26
        },
        end: {
          line: 100,
          column: 71
        }
      },
      "34": {
        start: {
          line: 101,
          column: 2
        },
        end: {
          line: 101,
          column: 25
        }
      },
      "35": {
        start: {
          line: 104,
          column: 28
        },
        end: {
          line: 114,
          column: 1
        }
      },
      "36": {
        start: {
          line: 105,
          column: 20
        },
        end: {
          line: 105,
          column: 73
        }
      },
      "37": {
        start: {
          line: 106,
          column: 18
        },
        end: {
          line: 106,
          column: 62
        }
      },
      "38": {
        start: {
          line: 110,
          column: 26
        },
        end: {
          line: 112,
          column: 65
        }
      },
      "39": {
        start: {
          line: 113,
          column: 2
        },
        end: {
          line: 113,
          column: 25
        }
      },
      "40": {
        start: {
          line: 116,
          column: 35
        },
        end: {
          line: 120,
          column: 1
        }
      },
      "41": {
        start: {
          line: 118,
          column: 19
        },
        end: {
          line: 118,
          column: 84
        }
      },
      "42": {
        start: {
          line: 119,
          column: 2
        },
        end: {
          line: 119,
          column: 61
        }
      },
      "43": {
        start: {
          line: 122,
          column: 27
        },
        end: {
          line: 162,
          column: 1
        }
      },
      "44": {
        start: {
          line: 123,
          column: 17
        },
        end: {
          line: 123,
          column: 20
        }
      },
      "45": {
        start: {
          line: 124,
          column: 2
        },
        end: {
          line: 126,
          column: 3
        }
      },
      "46": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 20
        }
      },
      "47": {
        start: {
          line: 128,
          column: 2
        },
        end: {
          line: 160,
          column: 3
        }
      },
      "48": {
        start: {
          line: 132,
          column: 6
        },
        end: {
          line: 148,
          column: 7
        }
      },
      "49": {
        start: {
          line: 140,
          column: 10
        },
        end: {
          line: 140,
          column: 94
        }
      },
      "50": {
        start: {
          line: 142,
          column: 8
        },
        end: {
          line: 142,
          column: 55
        }
      },
      "51": {
        start: {
          line: 143,
          column: 22
        },
        end: {
          line: 143,
          column: 43
        }
      },
      "52": {
        start: {
          line: 144,
          column: 8
        },
        end: {
          line: 147,
          column: 9
        }
      },
      "53": {
        start: {
          line: 145,
          column: 65
        },
        end: {
          line: 145,
          column: 77
        }
      },
      "54": {
        start: {
          line: 146,
          column: 10
        },
        end: {
          line: 146,
          column: 73
        }
      },
      "55": {
        start: {
          line: 149,
          column: 6
        },
        end: {
          line: 149,
          column: 12
        }
      },
      "56": {
        start: {
          line: 151,
          column: 6
        },
        end: {
          line: 151,
          column: 56
        }
      },
      "57": {
        start: {
          line: 152,
          column: 6
        },
        end: {
          line: 152,
          column: 12
        }
      },
      "58": {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 154,
          column: 55
        }
      },
      "59": {
        start: {
          line: 155,
          column: 6
        },
        end: {
          line: 155,
          column: 12
        }
      },
      "60": {
        start: {
          line: 157,
          column: 6
        },
        end: {
          line: 157,
          column: 66
        }
      },
      "61": {
        start: {
          line: 158,
          column: 6
        },
        end: {
          line: 158,
          column: 12
        }
      },
      "62": {
        start: {
          line: 161,
          column: 2
        },
        end: {
          line: 161,
          column: 18
        }
      },
      "63": {
        start: {
          line: 164,
          column: 31
        },
        end: {
          line: 167,
          column: 1
        }
      },
      "64": {
        start: {
          line: 165,
          column: 23
        },
        end: {
          line: 165,
          column: 90
        }
      },
      "65": {
        start: {
          line: 166,
          column: 2
        },
        end: {
          line: 166,
          column: 33
        }
      },
      "66": {
        start: {
          line: 169,
          column: 29
        },
        end: {
          line: 191,
          column: 1
        }
      },
      "67": {
        start: {
          line: 170,
          column: 17
        },
        end: {
          line: 170,
          column: 20
        }
      },
      "68": {
        start: {
          line: 171,
          column: 2
        },
        end: {
          line: 173,
          column: 3
        }
      },
      "69": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 172,
          column: 20
        }
      },
      "70": {
        start: {
          line: 175,
          column: 2
        },
        end: {
          line: 189,
          column: 3
        }
      },
      "71": {
        start: {
          line: 178,
          column: 26
        },
        end: {
          line: 178,
          column: 68
        }
      },
      "72": {
        start: {
          line: 179,
          column: 6
        },
        end: {
          line: 179,
          column: 75
        }
      },
      "73": {
        start: {
          line: 180,
          column: 6
        },
        end: {
          line: 180,
          column: 12
        }
      },
      "74": {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 182,
          column: 50
        }
      },
      "75": {
        start: {
          line: 183,
          column: 6
        },
        end: {
          line: 183,
          column: 12
        }
      },
      "76": {
        start: {
          line: 186,
          column: 6
        },
        end: {
          line: 186,
          column: 74
        }
      },
      "77": {
        start: {
          line: 187,
          column: 6
        },
        end: {
          line: 187,
          column: 12
        }
      },
      "78": {
        start: {
          line: 190,
          column: 2
        },
        end: {
          line: 190,
          column: 18
        }
      },
      "79": {
        start: {
          line: 201,
          column: 49
        },
        end: {
          line: 206,
          column: 1
        }
      },
      "80": {
        start: {
          line: 202,
          column: 23
        },
        end: {
          line: 202,
          column: 61
        }
      },
      "81": {
        start: {
          line: 204,
          column: 4
        },
        end: {
          line: 204,
          column: 93
        }
      },
      "82": {
        start: {
          line: 205,
          column: 2
        },
        end: {
          line: 205,
          column: 44
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 43,
            column: 21
          },
          end: {
            line: 43,
            column: 22
          }
        },
        loc: {
          start: {
            line: 43,
            column: 57
          },
          end: {
            line: 59,
            column: 1
          }
        },
        line: 43
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 44,
            column: 21
          },
          end: {
            line: 44,
            column: 22
          }
        },
        loc: {
          start: {
            line: 44,
            column: 34
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 44
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 48,
            column: 13
          },
          end: {
            line: 48,
            column: 14
          }
        },
        loc: {
          start: {
            line: 48,
            column: 19
          },
          end: {
            line: 48,
            column: 30
          }
        },
        line: 48
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 49,
            column: 17
          },
          end: {
            line: 49,
            column: 18
          }
        },
        loc: {
          start: {
            line: 49,
            column: 33
          },
          end: {
            line: 55,
            column: 7
          }
        },
        line: 49
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 61,
            column: 34
          },
          end: {
            line: 61,
            column: 35
          }
        },
        loc: {
          start: {
            line: 63,
            column: 54
          },
          end: {
            line: 67,
            column: 1
          }
        },
        line: 63
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 69,
            column: 32
          },
          end: {
            line: 69,
            column: 33
          }
        },
        loc: {
          start: {
            line: 69,
            column: 60
          },
          end: {
            line: 72,
            column: 1
          }
        },
        line: 69
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 74,
            column: 35
          },
          end: {
            line: 74,
            column: 36
          }
        },
        loc: {
          start: {
            line: 78,
            column: 14
          },
          end: {
            line: 89,
            column: 1
          }
        },
        line: 78
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 91,
            column: 29
          },
          end: {
            line: 91,
            column: 30
          }
        },
        loc: {
          start: {
            line: 91,
            column: 79
          },
          end: {
            line: 102,
            column: 1
          }
        },
        line: 91
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 104,
            column: 28
          },
          end: {
            line: 104,
            column: 29
          }
        },
        loc: {
          start: {
            line: 104,
            column: 78
          },
          end: {
            line: 114,
            column: 1
          }
        },
        line: 104
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 116,
            column: 35
          },
          end: {
            line: 116,
            column: 36
          }
        },
        loc: {
          start: {
            line: 116,
            column: 85
          },
          end: {
            line: 120,
            column: 1
          }
        },
        line: 116
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 122,
            column: 27
          },
          end: {
            line: 122,
            column: 28
          }
        },
        loc: {
          start: {
            line: 122,
            column: 89
          },
          end: {
            line: 162,
            column: 1
          }
        },
        line: 122
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 164,
            column: 31
          },
          end: {
            line: 164,
            column: 32
          }
        },
        loc: {
          start: {
            line: 164,
            column: 58
          },
          end: {
            line: 167,
            column: 1
          }
        },
        line: 164
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 169,
            column: 29
          },
          end: {
            line: 169,
            column: 30
          }
        },
        loc: {
          start: {
            line: 169,
            column: 68
          },
          end: {
            line: 191,
            column: 1
          }
        },
        line: 169
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 201,
            column: 49
          },
          end: {
            line: 201,
            column: 50
          }
        },
        loc: {
          start: {
            line: 201,
            column: 76
          },
          end: {
            line: 206,
            column: 1
          }
        },
        line: 201
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 54,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 54,
            column: 9
          }
        }, {
          start: {
            line: 52,
            column: 15
          },
          end: {
            line: 54,
            column: 9
          }
        }],
        line: 50
      },
      "1": {
        loc: {
          start: {
            line: 64,
            column: 16
          },
          end: {
            line: 64,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 16
          },
          end: {
            line: 64,
            column: 67
          }
        }, {
          start: {
            line: 64,
            column: 71
          },
          end: {
            line: 64,
            column: 85
          }
        }],
        line: 64
      },
      "2": {
        loc: {
          start: {
            line: 71,
            column: 9
          },
          end: {
            line: 71,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 9
          },
          end: {
            line: 71,
            column: 14
          }
        }, {
          start: {
            line: 71,
            column: 18
          },
          end: {
            line: 71,
            column: 33
          }
        }],
        line: 71
      },
      "3": {
        loc: {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 82
      },
      "4": {
        loc: {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 14
          }
        }, {
          start: {
            line: 82,
            column: 18
          },
          end: {
            line: 82,
            column: 37
          }
        }],
        line: 82
      },
      "5": {
        loc: {
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 85
      },
      "6": {
        loc: {
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 85,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 85,
            column: 14
          }
        }, {
          start: {
            line: 85,
            column: 18
          },
          end: {
            line: 85,
            column: 37
          }
        }],
        line: 85
      },
      "7": {
        loc: {
          start: {
            line: 100,
            column: 12
          },
          end: {
            line: 100,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 100,
            column: 41
          },
          end: {
            line: 100,
            column: 42
          }
        }, {
          start: {
            line: 100,
            column: 45
          },
          end: {
            line: 100,
            column: 70
          }
        }],
        line: 100
      },
      "8": {
        loc: {
          start: {
            line: 112,
            column: 12
          },
          end: {
            line: 112,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 112,
            column: 41
          },
          end: {
            line: 112,
            column: 42
          }
        }, {
          start: {
            line: 112,
            column: 45
          },
          end: {
            line: 112,
            column: 64
          }
        }],
        line: 112
      },
      "9": {
        loc: {
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 126,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 126,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 124
      },
      "10": {
        loc: {
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 124,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 124,
            column: 15
          }
        }, {
          start: {
            line: 124,
            column: 19
          },
          end: {
            line: 124,
            column: 40
          }
        }],
        line: 124
      },
      "11": {
        loc: {
          start: {
            line: 128,
            column: 2
          },
          end: {
            line: 160,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 149,
            column: 12
          }
        }, {
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 152,
            column: 12
          }
        }, {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 155,
            column: 12
          }
        }, {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 158,
            column: 12
          }
        }, {
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 159,
            column: 12
          }
        }],
        line: 128
      },
      "12": {
        loc: {
          start: {
            line: 132,
            column: 6
          },
          end: {
            line: 148,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 6
          },
          end: {
            line: 148,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 132
      },
      "13": {
        loc: {
          start: {
            line: 132,
            column: 12
          },
          end: {
            line: 132,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 132,
            column: 12
          },
          end: {
            line: 132,
            column: 31
          }
        }, {
          start: {
            line: 132,
            column: 35
          },
          end: {
            line: 132,
            column: 55
          }
        }],
        line: 132
      },
      "14": {
        loc: {
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 144
      },
      "15": {
        loc: {
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 173,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 173,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 171
      },
      "16": {
        loc: {
          start: {
            line: 171,
            column: 6
          },
          end: {
            line: 171,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 171,
            column: 6
          },
          end: {
            line: 171,
            column: 15
          }
        }, {
          start: {
            line: 171,
            column: 19
          },
          end: {
            line: 171,
            column: 40
          }
        }],
        line: 171
      },
      "17": {
        loc: {
          start: {
            line: 175,
            column: 2
          },
          end: {
            line: 189,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 176,
            column: 4
          },
          end: {
            line: 180,
            column: 12
          }
        }, {
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 183,
            column: 12
          }
        }, {
          start: {
            line: 184,
            column: 4
          },
          end: {
            line: 184,
            column: 18
          }
        }, {
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 187,
            column: 12
          }
        }, {
          start: {
            line: 188,
            column: 4
          },
          end: {
            line: 188,
            column: 12
          }
        }],
        line: 175
      },
      "18": {
        loc: {
          start: {
            line: 179,
            column: 18
          },
          end: {
            line: 179,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 179,
            column: 32
          },
          end: {
            line: 179,
            column: 58
          }
        }, {
          start: {
            line: 179,
            column: 61
          },
          end: {
            line: 179,
            column: 63
          }
        }],
        line: 179
      },
      "19": {
        loc: {
          start: {
            line: 204,
            column: 4
          },
          end: {
            line: 204,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 204,
            column: 37
          },
          end: {
            line: 204,
            column: 62
          }
        }, {
          start: {
            line: 204,
            column: 65
          },
          end: {
            line: 204,
            column: 93
          }
        }],
        line: 204
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0, 0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0, 0, 0, 0],
      "18": [0, 0],
      "19": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9061f879f06d761431a15347495d4a2fae637557"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_25bxqxe5o4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_25bxqxe5o4();
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = new RegExp(e, t); return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++; r[t] = e[o[i]]; } return r; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) { var t = o[r]; return "$" + (Array.isArray(t) ? t.join("$") : t); })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != _typeof(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }








































/* no-es-lib-transform - prevent mortar from breaking this path */


var mailcheckDefaultTopLevelDomains = (cov_25bxqxe5o4().s[0]++, ['com', 'net', 'org', 'info', 'edu']);
var stripDollarCommaPercentPunctuation = (cov_25bxqxe5o4().s[1]++, /\$|,|%/g);
var stripNonDigitPeriod = (cov_25bxqxe5o4().s[2]++, /[^\d.]/g);
var commaPositionsWithoutDecimal = (cov_25bxqxe5o4().s[3]++, /\d(?=(?:\d{3})+$)/g);
var commaPositionsWithDecimal = (cov_25bxqxe5o4().s[4]++, /\d(?=(?:\d{3})+(?:\.\d*)$)/g);
var mailcheckDefaultDomains = (cov_25bxqxe5o4().s[5]++, [
// Keep in sync with app/services/BriteVerifyService
'yahoo.com', 'google.com', 'hotmail.com', 'gmail.com', 'me.com', 'aol.com', 'mac.com', 'live.com', 'comcast.net', 'googlemail.com', 'msn.com', 'facebook.com', 'verizon.net', 'sbcglobal.net', 'att.net', 'mail.com', 'outlook.com', 'icloud.com', 'cox.net']);
var BLACKLISTED_TLDS = (cov_25bxqxe5o4().s[6]++, ['como', 'comp', 'con', 'met', 'ner', 'vom']);
cov_25bxqxe5o4().s[7]++;
var suggestEmail = function suggestEmail(email) {
  cov_25bxqxe5o4().f[0]++;
  cov_25bxqxe5o4().s[8]++;
  return new Promise(function (resolve) {
    cov_25bxqxe5o4().f[1]++;
    cov_25bxqxe5o4().s[9]++;
    mailcheck__WEBPACK_IMPORTED_MODULE_41__.run({
      domains: mailcheckDefaultDomains,
      email: email,
      empty: function empty() {
        cov_25bxqxe5o4().f[2]++;
        cov_25bxqxe5o4().s[10]++;
        return resolve('');
      },
      suggested: function suggested(suggestion) {
        cov_25bxqxe5o4().f[3]++;
        cov_25bxqxe5o4().s[11]++;
        if (lodash_includes_js__WEBPACK_IMPORTED_MODULE_1__(lodash_get_js__WEBPACK_IMPORTED_MODULE_2__(suggestion, 'domain'), '.')) {
          cov_25bxqxe5o4().b[0][0]++;
          cov_25bxqxe5o4().s[12]++;
          resolve(JSON.stringify(lodash_get_js__WEBPACK_IMPORTED_MODULE_2__(suggestion, 'full')).replace(/"/g, ''));
        } else {
          cov_25bxqxe5o4().b[0][1]++;
          cov_25bxqxe5o4().s[13]++;
          resolve('');
        }
      },
      topLevelDomains: mailcheckDefaultTopLevelDomains
    });
  });
};
cov_25bxqxe5o4().s[14]++;
var checkEmailValidity = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(value) {
    var valid, suggestion;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          cov_25bxqxe5o4().f[4]++;
          valid = (cov_25bxqxe5o4().s[15]++, (cov_25bxqxe5o4().b[1][0]++, !lodash_includes_js__WEBPACK_IMPORTED_MODULE_1__(BLACKLISTED_TLDS, lodash_last_js__WEBPACK_IMPORTED_MODULE_0__(value.split('.')))) && (cov_25bxqxe5o4().b[1][1]++, validator_lib_isEmail_js__WEBPACK_IMPORTED_MODULE_42__(value)));
          cov_25bxqxe5o4().s[16]++;
          _context.next = 5;
          return suggestEmail(value);
        case 5:
          suggestion = _context.sent;
          cov_25bxqxe5o4().s[17]++;
          return _context.abrupt("return", {
            valid: valid,
            suggestion: suggestion
          });
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function checkEmailValidity(_x) {
    return _ref.apply(this, arguments);
  };
}();
cov_25bxqxe5o4().s[18]++;
var checkTelValidity = function checkTelValidity(value) {
  cov_25bxqxe5o4().f[5]++;
  var phone = (cov_25bxqxe5o4().s[19]++, (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_43__/* .parsePhoneNumber */ .S)(value, 'US'));
  cov_25bxqxe5o4().s[20]++;
  return (cov_25bxqxe5o4().b[2][0]++, phone) && (cov_25bxqxe5o4().b[2][1]++, phone.isValid());
};
cov_25bxqxe5o4().s[21]++;
var checkNumberValidity = function checkNumberValidity(value, minValue, maxValue) {
  cov_25bxqxe5o4().f[6]++;
  var valid = (cov_25bxqxe5o4().s[22]++, true);
  var parsedNum = (cov_25bxqxe5o4().s[23]++, value.replace(stripDollarCommaPercentPunctuation, ''));
  var numValue = (cov_25bxqxe5o4().s[24]++, parseFloat(parsedNum));
  cov_25bxqxe5o4().s[25]++;
  if ((cov_25bxqxe5o4().b[4][0]++, minValue) && (cov_25bxqxe5o4().b[4][1]++, minValue > numValue)) {
    cov_25bxqxe5o4().b[3][0]++;
    cov_25bxqxe5o4().s[26]++;
    valid = false;
  } else {
    cov_25bxqxe5o4().b[3][1]++;
  }
  cov_25bxqxe5o4().s[27]++;
  if ((cov_25bxqxe5o4().b[6][0]++, maxValue) && (cov_25bxqxe5o4().b[6][1]++, maxValue < numValue)) {
    cov_25bxqxe5o4().b[5][0]++;
    cov_25bxqxe5o4().s[28]++;
    valid = false;
  } else {
    cov_25bxqxe5o4().b[5][1]++;
  }
  cov_25bxqxe5o4().s[29]++;
  return valid;
};
cov_25bxqxe5o4().s[30]++;
var formatPercent = function formatPercent(value, decimalPlaces) {
  cov_25bxqxe5o4().f[7]++;
  var parsedNum = (cov_25bxqxe5o4().s[31]++, value.replace(stripDollarCommaPercentPunctuation, ''));
  var rounded = (cov_25bxqxe5o4().s[32]++, parseFloat(parsedNum).toFixed(decimalPlaces));

  // NOTE: Intl.Numberformat automatically replaces insignificant digits in the number string with zeroes
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
  var formattedNumber = (cov_25bxqxe5o4().s[33]++, new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: decimalPlaces
  }).format(isNaN(parseFloat(rounded)) ? (cov_25bxqxe5o4().b[7][0]++, 0) : (cov_25bxqxe5o4().b[7][1]++, parseFloat(rounded) / 100)));
  cov_25bxqxe5o4().s[34]++;
  return formattedNumber;
};
cov_25bxqxe5o4().s[35]++;
var formatNumber = function formatNumber(value, decimalPlaces) {
  cov_25bxqxe5o4().f[8]++;
  var parsedNum = (cov_25bxqxe5o4().s[36]++, value.replace(stripDollarCommaPercentPunctuation, ''));
  var rounded = (cov_25bxqxe5o4().s[37]++, parseFloat(parsedNum).toFixed(decimalPlaces));

  // NOTE: Intl.Numberformat automatically replaces insignificant digits in the number string with zeroes
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
  var formattedNumber = (cov_25bxqxe5o4().s[38]++, new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimalPlaces
  }).format(isNaN(parseFloat(rounded)) ? (cov_25bxqxe5o4().b[8][0]++, 0) : (cov_25bxqxe5o4().b[8][1]++, parseFloat(rounded))));
  cov_25bxqxe5o4().s[39]++;
  return formattedNumber;
};
cov_25bxqxe5o4().s[40]++;
var formatCurrencyValue = function formatCurrencyValue(value, roundToCents) {
  cov_25bxqxe5o4().f[9]++;
  // Removes '$' and ',' characters from the value string in order to parse value as a number
  var numValue = (cov_25bxqxe5o4().s[41]++, parseFloat(value.replace(stripDollarCommaPercentPunctuation, '')));
  cov_25bxqxe5o4().s[42]++;
  return (0,_helpers_currencyHelpers_mjs__WEBPACK_IMPORTED_MODULE_44__/* .centsToCurrencyString */ .gn)(numValue * 100, roundToCents);
};
cov_25bxqxe5o4().s[43]++;
var formatValue = function formatValue(val, type, decimalPlaces) {
  cov_25bxqxe5o4().f[10]++;
  var newValue = (cov_25bxqxe5o4().s[44]++, val);
  cov_25bxqxe5o4().s[45]++;
  if ((cov_25bxqxe5o4().b[10][0]++, !newValue) || (cov_25bxqxe5o4().b[10][1]++, newValue.length === 0)) {
    cov_25bxqxe5o4().b[9][0]++;
    cov_25bxqxe5o4().s[46]++;
    return newValue;
  } else {
    cov_25bxqxe5o4().b[9][1]++;
  }
  cov_25bxqxe5o4().s[47]++;
  switch (type) {
    // format phone number input to the format of xxx-xxx-xxxx.
    case 'tel':
      cov_25bxqxe5o4().b[11][0]++;
      cov_25bxqxe5o4().s[48]++;
      // Prevents formatting when the changed value is just removing a parenthesis
      if (!((cov_25bxqxe5o4().b[13][0]++, newValue[0] === '(') && (cov_25bxqxe5o4().b[13][1]++, newValue.length <= 4))) {
        cov_25bxqxe5o4().b[12][0]++;
        /**
         * AsYouType format phone number into 3 ways:
         * number with + area code: +x xxx xxx xxxx.
         * number with area code: x (xxx) xxx-xxxx.
         * number without area code: (xxx) xxx-xxxx.
         */
        var regex = (cov_25bxqxe5o4().s[49]++, /*#__PURE__*/_wrapRegExp(/([\d]{3})\)? ([\d]{3})[- ]([\d]{4})/, {
          areaCode: 1,
          numberFirstThree: 2,
          numberLastFour: 3
        }));
        cov_25bxqxe5o4().s[50]++;
        newValue = new libphonenumber_js__WEBPACK_IMPORTED_MODULE_45__/* .AsYouType */ .R('US').input(newValue);
        var match = (cov_25bxqxe5o4().s[51]++, newValue.match(regex));
        cov_25bxqxe5o4().s[52]++;
        if (match) {
          cov_25bxqxe5o4().b[14][0]++;
          var _ref2 = (cov_25bxqxe5o4().s[53]++, match.groups),
            areaCode = _ref2.areaCode,
            numberFirstThree = _ref2.numberFirstThree,
            numberLastFour = _ref2.numberLastFour;
          cov_25bxqxe5o4().s[54]++;
          newValue = "".concat(areaCode, "-").concat(numberFirstThree, "-").concat(numberLastFour);
        } else {
          cov_25bxqxe5o4().b[14][1]++;
        }
      } else {
        cov_25bxqxe5o4().b[12][1]++;
      }
      cov_25bxqxe5o4().s[55]++;
      break;
    case 'percent':
      cov_25bxqxe5o4().b[11][1]++;
      cov_25bxqxe5o4().s[56]++;
      newValue = formatPercent(newValue, decimalPlaces);
      cov_25bxqxe5o4().s[57]++;
      break;
    case 'number':
      cov_25bxqxe5o4().b[11][2]++;
      cov_25bxqxe5o4().s[58]++;
      newValue = formatNumber(newValue, decimalPlaces);
      cov_25bxqxe5o4().s[59]++;
      break;
    case 'currency':
      cov_25bxqxe5o4().b[11][3]++;
      cov_25bxqxe5o4().s[60]++;
      newValue = formatCurrencyValue(newValue, decimalPlaces > 0);
      cov_25bxqxe5o4().s[61]++;
      break;
    default:
      cov_25bxqxe5o4().b[11][4]++;
  }
  cov_25bxqxe5o4().s[62]++;
  return newValue;
};
cov_25bxqxe5o4().s[63]++;
var percentStringToDecimal = function percentStringToDecimal(value) {
  cov_25bxqxe5o4().f[11]++;
  var percentValue = (cov_25bxqxe5o4().s[64]++, Number(value.replace(stripDollarCommaPercentPunctuation, '')) / 100);
  cov_25bxqxe5o4().s[65]++;
  return percentValue.toString();
};
cov_25bxqxe5o4().s[66]++;
var unformatValue = function unformatValue(val, type) {
  cov_25bxqxe5o4().f[12]++;
  var newValue = (cov_25bxqxe5o4().s[67]++, val);
  cov_25bxqxe5o4().s[68]++;
  if ((cov_25bxqxe5o4().b[16][0]++, !newValue) || (cov_25bxqxe5o4().b[16][1]++, newValue.length === 0)) {
    cov_25bxqxe5o4().b[15][0]++;
    cov_25bxqxe5o4().s[69]++;
    return newValue;
  } else {
    cov_25bxqxe5o4().b[15][1]++;
  }
  cov_25bxqxe5o4().s[70]++;
  switch (type) {
    case 'tel':
      cov_25bxqxe5o4().b[17][0]++;
      // eslint-disable-next-line no-case-declarations
      var phoneNumber = (cov_25bxqxe5o4().s[71]++, (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_43__/* .parsePhoneNumber */ .S)(newValue, 'US'));
      cov_25bxqxe5o4().s[72]++;
      newValue = phoneNumber ? (cov_25bxqxe5o4().b[18][0]++, phoneNumber.nationalNumber) : (cov_25bxqxe5o4().b[18][1]++, '');
      cov_25bxqxe5o4().s[73]++;
      break;
    case 'percent':
      cov_25bxqxe5o4().b[17][1]++;
      cov_25bxqxe5o4().s[74]++;
      newValue = percentStringToDecimal(newValue);
      cov_25bxqxe5o4().s[75]++;
      break;
    case 'number':
      cov_25bxqxe5o4().b[17][2]++;
    case 'currency':
      cov_25bxqxe5o4().b[17][3]++;
      cov_25bxqxe5o4().s[76]++;
      newValue = newValue.replace(stripDollarCommaPercentPunctuation, '');
      cov_25bxqxe5o4().s[77]++;
      break;
    default:
      cov_25bxqxe5o4().b[17][4]++;
  }
  cov_25bxqxe5o4().s[78]++;
  return newValue;
};

/*
  This function will strip any non digit or period characters then it will
  add commas to every third number after a decimal for added clarity while
  typing out a number in an input field.

  This does not format the value into the final output (i.e. formatValue) because
  we don't want to prematurely add decimals places to the input while typing.
*/
cov_25bxqxe5o4().s[79]++;
var sanitizeAndFormatNumberWithCommas = function sanitizeAndFormatNumberWithCommas(value) {
  cov_25bxqxe5o4().f[13]++;
  var sanitizedNum = (cov_25bxqxe5o4().s[80]++, value.replace(stripNonDigitPeriod, ''));
  var regex = (cov_25bxqxe5o4().s[81]++, sanitizedNum.indexOf('.') > -1 ? (cov_25bxqxe5o4().b[19][0]++, commaPositionsWithDecimal) : (cov_25bxqxe5o4().b[19][1]++, commaPositionsWithoutDecimal));
  cov_25bxqxe5o4().s[82]++;
  return sanitizedNum.replace(regex, '$&,');
};

/***/ })

}]);